<template>
  <!-- 版本列表 -->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="file-history"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" type="button" data-dismiss="modal">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">版本列表</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <div class="group-list-wrap clearfix">
              <p v-show="!fileHistories.length">{{ processing }}</p>
              <div class="group-list">
                <div class="head">#</div>
                <div class="name">修改时间</div>
                <div class="style">修改人</div>
                <div class="style1">版本</div>
                <div class="info">操作</div>
              </div>
              <div
                class="group-list"
                v-for="(item, index) in fileHistories"
                :key="index"
              >
                <div class="head">
                  {{ item.id }}
                </div>
                <div class="name" :title="item.edit_time">
                  {{ item.edit_time }}
                </div>
                <div class="style" :title="item.edit_user_name">
                  {{ item.edit_user_name ? item.edit_user_name : "-" }}
                </div>
                <div class="style1" :title="item.edit_user_name">
                  {{ item.version }}
                </div>
                <div class="info">
                  <a
                    v-if="right__file_version_back_delete_back_version"
                    title="删除"
                    @click="
                      deleteFileVersion(
                        item.version,
                        item.file_id,
                        item.group_id
                      )
                    "
                    ><i class="iconfont icon-trash"></i
                  ></a>
                  <a
                    title="下载"
                    @click="
                      downloadFileVersion(
                        item.version,
                        item.file_id,
                        item.group_id
                      )
                    "
                    ><i class="ti-download"></i
                  ></a>
                  <a
                  v-if="right__file_version_back_opera"
                    title="切换到此版本"
                    @click="
                      switchVersion(item.version, item.file_id, item.group_id)
                    "
                    ><i class="iconfont icon-history_back"></i
                  ></a>
                  <a
                    title="查看"
                    @click="
                      goToPreview(item.version, item.file_id, item.group_id)
                    "
                    ><i class="fa fa-file-o"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" type="button" @click="cancle">
            关闭
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getFileVersions,
  setFileVersion,
  downloadFileVersion,
  deleteFileVersion,
} from "@/api/drive/drive";
export default {
  name: "FileHistory",
  data() {
    return {
      processing: "暂无版本列表",
      params: {
        group_number: "",
        file_id: "",
      },
      fileHistories: [], // 版本列表
    };
  },
  props: {
    detail: {
      type: Object,
    },
  },
  computed: {
    right__file_version_back_delete_back_version () {
      return this.$store.getters.right__file_version_back_delete_back_version
    },
    right__file_version_back_opera () {
      return this.$store.getters.right__file_version_back_opera
    },
    isOwner() {
      return (
        this.$store.state.group.groupInfo.group_member_identity === "owner"
      );
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
  },
  methods: {
    goToPreview(version, file_id, group_number) {
      let routeUrl = this.$router.resolve({
        name: "preview",
        params: {
          number: file_id,
          group_number: group_number,
          version: version,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    downloadFileVersion(version, file_id, group_number) {
      downloadFileVersion({ group_number, file_id, version })
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href = res.entity[file_id] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    deleteFileVersion(version, file_id, group_number) {
      deleteFileVersion({ group_number, file_id, version })
        .then((res) => {
          if (res.status_code === 200) {
            this.getFileVersions();
            this.$message({
              type: "success",
              message: res.message,
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    switchVersion(version, file_id, group_number) {
      setFileVersion({ group_number, file_id, version })
        .then((res) => {
          if (res.status_code === 200) {
            this.getFileVersions();
            this.$message({
              type: "success",
              message: res.message,
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getFileVersions() {
      $("#file-history").css({ "margin-top": "0px" });
      const params = Object.assign({}, this.params, {
        file_id: this.detail.number,
        group_number: this.groupNumber,
      });
      getFileVersions(params)
        .then((res) => {
          if (res.status_code === 200) {
            this.fileHistories = res.entity.version_list;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    cancle() {
      $("#file-history").modal("hide");
    },
  },
  mounted() {
    $("#file-history").on("show.bs.modal", () => {
      this.$nextTick(() => {
        this.getFileVersions();
      });
    });
  },
  destroyed() {
    $("#file-history").off();
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .modal-lg {
    width: auto;
  }
  .group-list .head {
    display: none;
  }
  .group-list .name {
    width: 100px !important;
    padding-left: 0 !important;
  }
  .group-list .style {
    width: 70px !important;
    padding-left: 0 !important;
  }
  .group-list .style1 {
    display: none;
  }
  .group-list .info {
    padding-left: 0 !important;
  }
}

.group-list .head {
  width: 50px;
}
.group-list-wrap {
  height: 320px;
}
.group-list .name {
  width: 155px;
}
.group-list .style {
  width: 200px;
  float: left;
  padding-left: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.group-list .style1 {
  width: 60px;
  float: left;
  padding-left: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.group-list .info {
  padding-left: 10px;
  float: right;
  width: auto;
}
.group-list .info a {
  margin-left: 8px;
  float: right;
}
.ti-back-left {
  font-weight: bold;
}
.modal-body {
  padding: 0 30px 0px 30px;
}
.modal-body .form-group label {
  height: 36px;
  line-height: 36px;
}

/*分页*/
.disable {
  color: #eee;
}
.disable:hover {
  color: #eee !important;
  background-color: unset !important;
  cursor: unset;
}
.page {
  width: 100%;
}
.page ul li {
  display: inline-block;
  margin: 0 2px;
}
.page ul li a {
  min-width: 30px;
  height: 30px;
  display: block;
  text-align: center;
  line-height: 30px;
}
.page ul li a:hover {
  background: #006adf;
  color: #fff;
}
</style>